<template>
  <div v-if="show" class="modal-backdrop fade show"></div>
  <div v-if="show" class="modal fade show d-block" tabindex="-1">
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
      <div class="modal-content shadow-lg border-0 rounded-4">
        <!-- Header du Modal -->
        <div class="modal-header bg-gradient-dark text-white p-4 border-0">
          <div class="d-flex align-items-center gap-3">
            <div class="header-icon-box bg-emerald text-white rounded-3 p-2">
              <i class="fas fa-file-invoice-dollar fs-4"></i>
            </div>
            <div>
              <h4 class="modal-title fw-bold mb-0">Nouvelle Facture d'Achat</h4>
              <p class="text-white-50 small mb-0">Saisie des réceptions et incrémentation automatique du stock</p>
            </div>
          </div>
          <button type="button" class="btn-close btn-close-white" @click="closeModal"></button>
        </div>

        <!-- Corps du Modal -->
        <div class="modal-body p-4 bg-slate-50">
          <form @submit.prevent="submitForm">
            <!-- Card 1: Fournisseur & Reference -->
            <div class="form-section-card shadow-sm mb-4">
              <div class="section-card-title">
                <i class="fas fa-building text-emerald me-2"></i>Informations Fournisseur & Document
              </div>
              <div class="row g-3">
                <div class="col-md-4">
                  <label class="form-label-custom required">Nom du Fournisseur</label>
                  <input
                    type="text"
                    class="form-control-custom"
                    v-model="form.fournisseur"
                    placeholder="Ex: Electro Components SA"
                    required
                  />
                </div>

                <div class="col-md-4">
                  <label class="form-label-custom required">N° Facture Fournisseur</label>
                  <input
                    type="text"
                    class="form-control-custom"
                    v-model="form.numeroFactureFournisseur"
                    placeholder="Ex: FAC-2026-0987"
                    required
                  />
                </div>

                <div class="col-md-4">
                  <label class="form-label-custom">Matricule Fiscal</label>
                  <input
                    type="text"
                    class="form-control-custom"
                    v-model="form.matriculeFiscal"
                    placeholder="Ex: 1234567/A/P/000"
                  />
                </div>

                <div class="col-md-4">
                  <label class="form-label-custom required">Date Facture</label>
                  <input
                    type="date"
                    class="form-control-custom"
                    v-model="form.dateFacture"
                    required
                  />
                </div>

                <div class="col-md-4">
                  <label class="form-label-custom">Date d'Échéance</label>
                  <input
                    type="date"
                    class="form-control-custom"
                    v-model="form.dateEcheance"
                  />
                </div>

                <div class="col-md-4">
                  <label class="form-label-custom">Mode de Paiement</label>
                  <select class="form-select-custom" v-model="form.modePaiement">
                    <option value="virement">Virement Bancaire</option>
                    <option value="cheque">Chèque</option>
                    <option value="espece">Espèces</option>
                    <option value="traite">Traite</option>
                    <option value="carte_bancaire">Carte Bancaire</option>
                  </select>
                </div>

                <div class="col-md-12">
                  <label class="form-label-custom"><i class="fas fa-paperclip me-1 text-emerald"></i>Pièce Jointe (Facture Scannée / PDF)</label>
                  <input
                    type="file"
                    class="form-control-custom"
                    accept=".pdf,.png,.jpg,.jpeg"
                    @change="handleFileUpload"
                  />
                  <small class="text-emerald font-semibold mt-1 d-block" v-if="form.pieceJointe">
                    <i class="fas fa-check-circle me-1"></i>Document attaché avec succès.
                  </small>
                </div>
              </div>
            </div>

            <!-- Card 2: Lignes d'Achats & Incrémentation Stock -->
            <div class="form-section-card shadow-sm mb-4">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <div class="section-card-title mb-0">
                  <i class="fas fa-cubes text-emerald me-2"></i>Produits Achetés & Entrée en Stock
                </div>
                <button type="button" class="btn-add-line" @click="addLigne">
                  <i class="fas fa-plus me-1"></i>Ajouter une ligne
                </button>
              </div>

              <div class="table-responsive rounded-3 border">
                <table class="table align-middle mb-0 custom-lines-table">
                  <thead>
                    <tr>
                      <th style="width: 28%;">Désignation Produit</th>
                      <th style="width: 16%;">Catégorie</th>
                      <th style="width: 10%;">Qté</th>
                      <th style="width: 15%;">P.U HT (DT)</th>
                      <th style="width: 10%;">TVA (%)</th>
                      <th style="width: 15%;" class="text-end">Total TTC</th>
                      <th style="width: 6%;" class="text-center"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(ligne, index) in form.lignes" :key="index">
                      <td>
                        <input
                          type="text"
                          class="form-control-sm-custom mb-1"
                          v-model="ligne.designation"
                          placeholder="Nom ou référence produit"
                          required
                        />
                        <select
                          class="form-select-sm-custom text-slate-500"
                          v-model="ligne.produitId"
                          @change="onSelectProduct(index)"
                        >
                          <option value="">-- Choisir du catalogue --</option>
                          <option v-for="p in existingProducts" :key="p._id" :value="p._id">
                            {{ p.designation }} ({{ p.categorie }})
                          </option>
                        </select>
                      </td>

                      <td>
                        <select class="form-select-sm-custom" v-model="ligne.categorie" required>
                          <option value="GPS">GPS</option>
                          <option value="SIM">SIM</option>
                          <option value="Matiere Premiere">Matière Première</option>
                          <option value="Composant">Composant</option>
                          <option value="Emballage">Emballage</option>
                          <option value="Accessoire">Accessoire</option>
                          <option value="Produit Fini">Produit Fini</option>
                          <option value="Autre">Autre</option>
                        </select>
                      </td>

                      <td>
                        <input
                          type="number"
                          class="form-control-sm-custom text-center font-bold"
                          v-model.number="ligne.quantite"
                          min="1"
                          required
                        />
                      </td>

                      <td>
                        <input
                          type="number"
                          step="0.001"
                          class="form-control-sm-custom text-end"
                          v-model.number="ligne.prixUnitaireHT"
                          min="0"
                          required
                        />
                      </td>

                      <td>
                        <select class="form-select-sm-custom text-center" v-model.number="ligne.tva">
                          <option :value="19">19%</option>
                          <option :value="7">7%</option>
                          <option :value="13">13%</option>
                          <option :value="0">0%</option>
                        </select>
                      </td>

                      <td class="text-end font-bold text-emerald">
                        {{ calculateLineTTC(ligne).toFixed(3) }} DT
                      </td>

                      <td class="text-center">
                        <button
                          type="button"
                          class="btn-delete-line"
                          @click="removeLigne(index)"
                          :disabled="form.lignes.length === 1"
                        >
                          <i class="fas fa-trash-alt"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Card 3: Récapitulatif & Notes -->
            <div class="row g-3">
              <div class="col-md-7">
                <div class="form-section-card shadow-sm h-100">
                  <div class="section-card-title">
                    <i class="fas fa-comment-alt text-emerald me-2"></i>Observations & Remarques
                  </div>
                  <textarea
                    class="form-control-custom"
                    rows="3"
                    v-model="form.observations"
                    placeholder="Remarques éventuelles sur le fournisseur, conditions de transport..."
                  ></textarea>
                </div>
              </div>

              <div class="col-md-5">
                <div class="summary-card shadow-sm">
                  <div class="summary-row">
                    <span>Total HT :</span>
                    <strong class="font-monospaced">{{ totalHT.toFixed(3) }} DT</strong>
                  </div>
                  <div class="summary-row">
                    <span>Total TVA :</span>
                    <strong class="font-monospaced">{{ totalTVA.toFixed(3) }} DT</strong>
                  </div>
                  <div class="divider my-2"></div>
                  <div class="summary-row total-row">
                    <span>Total TTC :</span>
                    <strong class="font-monospaced text-emerald fs-4">{{ totalTTC.toFixed(3) }} DT</strong>
                  </div>
                </div>
              </div>
            </div>

            <!-- Actions Footer -->
            <div class="d-flex justify-content-end gap-3 mt-4 pt-3 border-top">
              <button type="button" class="btn-secondary-custom" @click="closeModal">Annuler</button>
              <button type="submit" class="btn-submit-emerald" :disabled="loading">
                <i class="fas" :class="loading ? 'fa-spinner fa-spin' : 'fa-check-circle'"></i>
                <span>{{ loading ? 'Validation en cours...' : 'Valider & Incrémenter le Stock' }}</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import achatsService from '@/services/achatsService';
import api from '@/services/api';

export default {
  name: 'FactureAchatModal',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      existingProducts: [],
      form: {
        fournisseur: '',
        numeroFactureFournisseur: '',
        matriculeFiscal: '',
        dateFacture: new Date().toISOString().slice(0, 10),
        dateEcheance: '',
        modePaiement: 'virement',
        pieceJointe: '',
        observations: '',
        lignes: [
          {
            produitId: '',
            designation: '',
            categorie: 'Matiere Premiere',
            quantite: 1,
            prixUnitaireHT: 0,
            tva: 19
          }
        ]
      }
    };
  },
  computed: {
    totalHT() {
      return this.form.lignes.reduce((sum, l) => sum + (l.quantite * l.prixUnitaireHT || 0), 0);
    },
    totalTVA() {
      return this.form.lignes.reduce((sum, l) => {
        const ht = l.quantite * l.prixUnitaireHT || 0;
        return sum + (ht * (l.tva || 19) / 100);
      }, 0);
    },
    totalTTC() {
      return this.totalHT + this.totalTVA;
    }
  },
  mounted() {
    this.fetchProducts();
  },
  methods: {
    async fetchProducts() {
      try {
        const response = await api.get('/stock/products');
        if (response.data && response.data.data) {
          this.existingProducts = response.data.data.docs || response.data.data;
        }
      } catch (err) {
        console.error('Erreur chargement produits:', err);
      }
    },
    addLigne() {
      this.form.lignes.push({
        produitId: '',
        designation: '',
        categorie: 'Composant',
        quantite: 1,
        prixUnitaireHT: 0,
        tva: 19
      });
    },
    removeLigne(index) {
      if (this.form.lignes.length > 1) {
        this.form.lignes.splice(index, 1);
      }
    },
    onSelectProduct(index) {
      const pid = this.form.lignes[index].produitId;
      if (pid) {
        const prod = this.existingProducts.find(p => p._id === pid);
        if (prod) {
          this.form.lignes[index].designation = prod.designation;
          this.form.lignes[index].categorie = prod.categorie || 'Matiere Premiere';
          this.form.lignes[index].prixUnitaireHT = prod.prixAchat || 0;
        }
      }
    },
    calculateLineTTC(ligne) {
      const ht = (ligne.quantite || 0) * (ligne.prixUnitaireHT || 0);
      return ht * (1 + (ligne.tva || 19) / 100);
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.form.pieceJointe = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    closeModal() {
      this.$emit('close');
    },
    async submitForm() {
      try {
        this.loading = true;
        const res = await achatsService.createFacture(this.form);
        if (res.success) {
          this.$toast.success('Facture d\'achat enregistrée et stock incrémenté avec succès !');
          this.$emit('created');
          this.closeModal();
        } else {
          this.$toast.error(res.message || 'Erreur lors de l\'enregistrement');
        }
      } catch (error) {
        console.error('Erreur soumission facture achat:', error);
        this.$toast.error(error.response?.data?.message || 'Erreur lors de l\'enregistrement de la facture');
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.bg-gradient-dark {
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
}

.bg-emerald {
  background-color: #059669;
}

.text-emerald {
  color: #059669;
}

.bg-slate-50 {
  background-color: #f8fafc;
}

.form-section-card {
  background: white;
  border-radius: 14px;
  padding: 1.25rem 1.5rem;
  border: 1px solid #e2e8f0;
}

.section-card-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 1rem;
}

.form-label-custom {
  font-size: 0.82rem;
  font-weight: 600;
  color: #475569;
  margin-bottom: 0.35rem;
}

.form-label-custom.required::after {
  content: ' *';
  color: #ef4444;
}

.form-control-custom,
.form-select-custom {
  width: 100%;
  padding: 0.65rem 0.85rem;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  font-size: 0.88rem;
  color: #1e293b;
}

.form-control-custom:focus,
.form-select-custom:focus {
  outline: none;
  border-color: #059669;
  box-shadow: 0 0 0 3px rgba(5, 150, 105, 0.12);
}

.btn-add-line {
  padding: 0.4rem 0.85rem;
  background: rgba(5, 150, 105, 0.1);
  color: #059669;
  font-weight: 700;
  font-size: 0.82rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-add-line:hover {
  background: #059669;
  color: white;
}

.custom-lines-table th {
  background-color: #f1f5f9;
  color: #475569;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
}

.form-control-sm-custom,
.form-select-sm-custom {
  width: 100%;
  padding: 0.45rem 0.65rem;
  border-radius: 6px;
  border: 1px solid #cbd5e1;
  font-size: 0.85rem;
}

.btn-delete-line {
  background: none;
  border: none;
  color: #ef4444;
  cursor: pointer;
  font-size: 0.95rem;
}

.btn-delete-line:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.summary-card {
  background: #0f172a;
  color: white;
  border-radius: 14px;
  padding: 1.25rem 1.5rem;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.divider {
  border-top: 1px solid rgba(255, 255, 255, 0.15);
}

.btn-secondary-custom {
  padding: 0.65rem 1.4rem;
  border-radius: 10px;
  border: 1px solid #cbd5e1;
  background: white;
  color: #475569;
  font-weight: 600;
}

.btn-submit-emerald {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.65rem 1.6rem;
  border-radius: 10px;
  border: none;
  background: linear-gradient(135deg, #059669 0%, #10b981 100%);
  color: white;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.btn-submit-emerald:hover {
  background: linear-gradient(135deg, #047857 0%, #059669 100%);
}
</style>
